'use strict';
module.exports = function navigationEscape(toEscape, escapeChar) {
	if (!toEscape) {
		return toEscape;
	}
	escapeChar = escapeChar || '_';
	return toEscape.replace(/[,;#/\t\n\r]+/g, escapeChar).trim();
};
